import { BehaviorSubject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { BlackjackStylesType } from '../../model/blackjack-types';

export class RoundedLabelViewModel {
  public get currentText$() {
    return this.currentText.asObservable();
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get labelFill() {
    return this.gameServices.gameThemeService.getHexColor(BlackjackStylesType.LabelFill);
  }

  private readonly currentText: BehaviorSubject<string>;

  constructor(
    private gameServices: GameServices,
    text: string,
    readonly backgroundColor: number,
    readonly backgroundAlpha: number,
  ) {
    this.currentText = new BehaviorSubject<string>(text);
  }

  public setText(text: string): void {
    this.currentText.next(text);
  }
}
